import {
  DropdownPanel,
  Icon,
  Tooltip,
  TooltipAdvancedContent,
} from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { Dispatch, SetStateAction } from "react";
import { useRef } from "react";
import { useRootStore } from "../../../../stores/hooks";
import { getLocalCssColorVariables } from "../../../../utils/cssVariablesUtils";
import { AutomationDescriptionPopup } from "./DescrptionEditPopup";
import { StyledInfoButton } from "./style";

export const AutomationDescriptionButton = observer<{
  isEditActive: boolean;
  setIsEditActive: Dispatch<SetStateAction<boolean>>;
}>(({ isEditActive, setIsEditActive }) => {
  const store = useRootStore();
  const { candidate } = store.automations;
  const descriptionBtnRef = useRef<HTMLButtonElement>(null);
  const descriptionInfoBtn = (
    <StyledInfoButton
      ref={descriptionBtnRef}
      className={isEditActive ? "active" : ""}
    >
      <Icon
        name="info-filled"
        size="S"
        onClick={() => {
          setIsEditActive(true);
        }}
        opacity={1}
      />
    </StyledInfoButton>
  );

  const onSave = (description: string): void => {
    candidate.updateDescription(description);
    setIsEditActive(false);
  };

  return (
    <>
      {isEditActive ? (
        <>
          {descriptionInfoBtn}
          <DropdownPanel
            my="center top"
            at="center bottom+10"
            isActive={isEditActive}
            targetElementRef={
              descriptionBtnRef as React.MutableRefObject<HTMLButtonElement>
            }
            enableWidthCalculation={true}
            minWidth={340}
            arrowBackground="white"
            portalStyles={getLocalCssColorVariables(store.theme)}
            onClickOutside={() => setIsEditActive(false)}
          >
            <AutomationDescriptionPopup
              isEditActive={isEditActive}
              onCancel={() => setIsEditActive(false)}
              onSave={onSave}
            />
          </DropdownPanel>
        </>
      ) : (
        candidate.self.description?.length > 0 && (
          <Tooltip
            display="inline-flex"
            target={descriptionInfoBtn}
            padding={0}
            placements={["bottom"]}
            maxWidth={350}
            renderTooltipContent={
              <TooltipAdvancedContent
                title={candidate.self.label}
                text={candidate.self.description.replace(/\n/g, "<BR />")}
              />
            }
          />
        )
      )}
    </>
  );
});
